/**
 * @file The refusal a FormType save takes when the derive draft could not be JUDGED: a table it
 * reads had not arrived yet, so `validateFormDeriveDraft` was asked about tables it did not hold.
 * Thrown by `useLayoutEditorForm`'s `onSave`, caught by `LayoutEditorToolbar`.
 * Distinct from `FormDerivesBlockedError` on purpose: nothing is wrong with the configuration, so no
 * modal opens and the toolbar stays where the admin was — it asks for the save again once the tables
 * are in. A verdict computed against tables that have not loaded is not a verdict, and saving on it
 * would let a cyclic configuration through, which is why the save refuses rather than proceeds.
 */
import type { ArTableId } from '#types';

class FormDerivesUncheckedError extends Error {
  /** The tables the draft names and the editor did not hold when the save was attempted. */
  readonly missingTableIds: readonly ArTableId[];

  constructor(missingTableIds: readonly ArTableId[]) {
    super('Derived values could not be checked because their tables have not loaded.');
    this.name = 'FormDerivesUncheckedError';
    this.missingTableIds = missingTableIds;
  }
}

export { FormDerivesUncheckedError };
